(function ($) {
  /** global: Craft */
  /** global: Garnish */
  /**
   * Matrix input class
   */
  Craft.MatrixInput = Garnish.Base.extend(
    {
      id: null,
      entryTypes: null,
      entryTypesByHandle: null,
      inputNamePrefix: null,
      inputIdPrefix: null,

      $container: null,
      $form: null,
      $entriesContainer: null,
      $addEntryBtnContainer: null,
      $addEntryBtn: null,
      $addEntryMenuBtn: null,
      $pasteBtn: null,
      $statusMessage: null,

      entrySort: null,
      entrySelect: null,

      /**
       * @type {Craft.ElementEditor|null}
       */
      elementEditor: null,

      addingEntry: false,

      init: function (id, entryTypes, inputNamePrefix, settings) {
        this.id = id;
        this.entryTypes = entryTypes;
        this.inputNamePrefix = inputNamePrefix;
        this.inputIdPrefix = Craft.formatInputId(this.inputNamePrefix);

        // see if settings was actually set to the maxEntries value
        if (typeof settings === 'number') {
          settings = {maxEntries: settings};
        }
        this.setSettings(settings, Craft.MatrixInput.defaults);

        this.$container = $('#' + this.id);
        this.$form = this.$container.closest('form');
        this.$entriesContainer = this.$container.children('.blocks');
        this.$addEntryBtnContainer = this.$container.children('.buttons');
        this.$addEntryBtn =
          this.$addEntryBtnContainer.find('.btn:not(.menubtn)');
        this.$addEntryMenuBtn = this.$addEntryBtnContainer.find('.menubtn');
        this.$statusMessage = this.$container.find('[data-status-message]');

        this.$container.data('matrix', this);

        this.entryTypesByHandle = {};

        for (let i = 0; i < this.entryTypes.length; i++) {
          const entryType = this.entryTypes[i];
          this.entryTypesByHandle[entryType.handle] = entryType;
        }

        const $entries = this.$entriesContainer.children('.matrixblock');
        const collapsedEntries = Craft.MatrixInput.getCollapsedEntryIds();

        // only initialise drag-sort if the device has mouse events
        if (Craft.hasMousePointerEvents()) {
          this.entrySort = new Garnish.DragSort($entries, {
            handle: '> .actions > .move-btn',
            ignoreHandleSelector: null,
            axis: 'y',
            filter: () => {
              // Only return all the selected items if the target item is selected
              if (this.entrySort.$targetItem.hasClass('sel')) {
                return this.entrySelect.getSelectedItems();
              } else {
                return this.entrySort.$targetItem;
              }
            },
            collapseDraggees: true,
            magnetStrength: 4,
            helperLagBase: 1.5,
            helperOpacity: 0.9,
            onDragStop: () => {
              this.trigger('entrySortDragStop');
            },
            onSortChange: () => {
              this.entrySelect.resetItemOrder();
            },
          });
        } else {
          // hide the diamond icon (for drag-sort) if the device is touch-capable
          $('.actions > .move-btn').hide();
        }

        this.entrySelect = new Garnish.Select(
          this.$entriesContainer,
          $entries,
          {
            multi: true,
            vertical: true,
            handle: '> .actions > .checkbox, > .titlebar',
            filter: (target) => {
              return !$(target).closest('.tab-label').length;
            },
            checkboxMode: true,
          }
        );

        for (let i = 0; i < $entries.length; i++) {
          const $entry = $($entries[i]);
          const entry = new Craft.MatrixInput.Entry(this, $entry);

          if (entry.id && $.inArray('' + entry.id, collapsedEntries) !== -1) {
            entry.collapse();
          }
        }

        this.addListener(this.$addEntryBtn, 'activate', async function () {
          if (this.$addEntryBtn.hasClass('loading')) {
            return;
          }
          this.$addEntryBtn.addClass('loading');
          Craft.cp.announce(Craft.t('app', 'Loading'));
          try {
            await this.addEntry(this.$addEntryBtn.data('type'));
          } finally {
            this.$addEntryBtn.removeClass('loading');
          }
        });

        this.$addEntryMenuBtn.each((i, btn) => {
          const $btn = $(btn);
          $btn
            .disclosureMenu()
            .data('disclosureMenu')
            .$container.find('button')
            .on('activate', async (ev) => {
              $btn.addClass('loading');
              Craft.cp.announce(Craft.t('app', 'Loading'));
              try {
                await this.addEntry($(ev.currentTarget).data('type'));
              } finally {
                $btn.removeClass('loading');
              }
            });
        });

        this.updateAddEntryBtn();

        setTimeout(() => {
          this.elementEditor = this.$container
            .closest('form')
            .data('elementEditor');

          if (this.elementEditor) {
            this.elementEditor.on('update', () => {
              this.settings.ownerId = this.elementEditor.getDraftElementId(
                this.settings.ownerId
              );
            });
          }

          this.trigger('afterInit');
        }, 100);

        // If this field is nested within something that's deletable, be ready to handle that
        this.$container.closest('.js-deletable').on('delete', (ev) => {
          // Ignore delete events that came from nested elements
          if (ev.target === ev.currentTarget) {
            this.destroy();
          }
        });

        Craft.cp.onCopyElements((elementInfo, buttonLabel) => {
          this.updatePasteBtn(elementInfo);
          if (this.$pasteBtn && buttonLabel) {
            this.$pasteBtn.find('.label').text(buttonLabel);
          }
        });
      },

      canAddMoreEntries: function (num = 1) {
        if (num === 0) {
          return false;
        }

        return (
          !this.maxEntries ||
          this.$entriesContainer.children().length + num <= this.maxEntries
        );
      },

      canPaste(elementInfo) {
        if (!this.canAddMoreEntries(elementInfo.length)) {
          return false;
        }

        for (const e of elementInfo) {
          if (e.type !== 'craft\\elements\\Entry') {
            return false;
          }
        }

        const entryTypeIds = this.entryTypes.map((entryType) => entryType.id);
        for (const info of elementInfo) {
          if (!entryTypeIds.includes(info.data.entryTypeId)) {
            return false;
          }
        }

        return true;
      },

      async pasteEntries() {
        Craft.cp.announce(Craft.t('app', 'Loading'));
        this.$pasteBtn.addClass('loading');

        try {
          if (this.elementEditor) {
            // First ensure we're working with drafts for all elements leading up
            // to this field’s element
            await this.elementEditor.setFormValue(
              this.settings.baseInputName,
              '*'
            );
          }

          const newElementInfo = await Craft.cp.pasteElements({
            primaryOwnerId: this.settings.ownerId,
            ownerId: this.settings.ownerId,
            fieldId: this.settings.fieldId,
            siteId: this.settings.siteId,
          });

          if (!newElementInfo.length) {
            return;
          }

          let data;
          try {
            const response = await Craft.sendActionRequest(
              'POST',
              'matrix/render-blocks',
              {
                data: {
                  entryIds: newElementInfo.map((info) => info.id),
                  siteId: this.settings.siteId,
                  namespace: this.settings.namespace,
                },
              }
            );
            data = response.data;
          } catch (e) {
            Craft.cp.displayError(e?.response?.data?.message);
            return;
          }

          // Pause the element editor
          await this.elementEditor?.pause();

          const $newEntries = $(data.blockHtml);
          this.$entriesContainer.append($newEntries);
          await Craft.appendHeadHtml(data.headHtml);
          await Craft.appendBodyHtml(data.bodyHtml);
          Craft.initUiElements($newEntries);

          $newEntries.each((i, entry) => {
            const $entry = $(entry);
            new Craft.MatrixInput.Entry(this, $entry);
            this.trigger('entryAdded', {
              $entry,
            });
          });

          this.entrySort?.addItems($newEntries);
          this.entrySelect.addItems($newEntries);
          this.updateAddEntryBtn();
          Garnish.firstFocusableElement($newEntries).focus();
        } finally {
          this.$pasteBtn.removeClass('loading');
        }

        // Resume the element editor
        this.elementEditor?.resume();
      },

      updateAddEntryBtn: function () {
        if (this.canAddMoreEntries()) {
          this.$addEntryBtn.removeClass('disabled').removeAttr('aria-disabled');
          this.$addEntryMenuBtn.removeClass('disabled');
        } else {
          this.$addEntryBtn.addClass('disabled').attr('aria-disabled', 'true');
          this.$addEntryMenuBtn.addClass('disabled');
        }

        this.updatePasteBtn();
      },

      updatePasteBtn: function (elementInfo = null) {
        elementInfo = elementInfo || Craft.cp.getCopiedElements();
        if (this.canPaste(elementInfo)) {
          if (!this.$pasteBtn) {
            this.$pasteBtn = Craft.ui
              .createPasteButton()
              .appendTo(this.$addEntryBtnContainer);
            this.addListener(this.$pasteBtn, 'activate', 'pasteEntries');
          } else {
            this.$pasteBtn.removeClass('hidden');
          }
        } else {
          this.$pasteBtn?.addClass('hidden');
        }
      },

      updateStatusMessage: function () {
        this.$statusMessage.empty();
        let message;

        if (!this.canAddMoreEntries()) {
          message = Craft.t(
            'app',
            'Entry could not be added. Maximum number of entries reached.'
          );
        }

        setTimeout(() => {
          this.$statusMessage.text(message);
        }, 250);
      },

      async addEntry(type, $insertBefore, autofocus = true, params = {}) {
        if (!this.canAddMoreEntries()) {
          this.updateStatusMessage();
          return;
        }

        if (this.elementEditor) {
          // First ensure we're working with drafts for all elements leading up
          // to this field’s element
          await this.elementEditor.setFormValue(
            this.settings.baseInputName,
            '*'
          );
        }

        const queue = this.elementEditor?.queue ?? Craft.queue;
        await queue.push(async () => {
          if (this.addingEntry) {
            // only one new entry at a time
            return;
          }

          this.addingEntry = true;

          const {data} = await Craft.sendActionRequest(
            'POST',
            'matrix/create-entry',
            {
              data: Object.assign(
                {
                  fieldId: this.settings.fieldId,
                  entryTypeId: this.entryTypesByHandle[type].id,
                  ownerId: this.settings.ownerId,
                  ownerElementType: this.settings.ownerElementType,
                  siteId: this.settings.siteId,
                  namespace: this.settings.namespace,
                  staticEntries: this.settings.staticEntries,
                },
                params
              ),
            }
          );

          const $entry = $(data.blockHtml);
          // hide the diamond icon (for drag-sort) if the device doesn't have mouse events
          if (!Craft.hasMousePointerEvents()) {
            $entry.find('.actions > .move-btn').hide();
          }

          // Pause the element editor
          await this.elementEditor?.pause();

          if ($insertBefore?.length) {
            $entry.insertBefore($insertBefore);
          } else {
            $entry.appendTo(this.$entriesContainer);
          }

          this.trigger('entryAdded', {
            $entry: $entry,
          });

          // Animate the entry into position
          $entry.css(this.getHiddenEntryCss($entry)).velocity(
            {
              opacity: 1,
              'margin-bottom': 8,
            },
            'fast',
            async () => {
              $entry.css('margin-bottom', '');
              // Execute the response JS first so any Selectize inputs, etc.,
              // get instantiated before field toggles
              await Craft.appendHeadHtml(data.headHtml);
              await Craft.appendBodyHtml(data.bodyHtml);
              Craft.initUiElements($entry.children('.fields'));
              new Craft.MatrixInput.Entry(this, $entry);
              this.entrySort?.addItems($entry);
              this.entrySelect.addItems($entry);
              this.updateAddEntryBtn();

              Garnish.requestAnimationFrame(() => {
                if (autofocus) {
                  // Scroll to the entry
                  Garnish.scrollContainerToElement($entry);
                  // Focus on the first focusable element
                  $entry
                    .find('.flex-fields :focusable')
                    .not('.prevent-autofocus')
                    .first()
                    .focus();
                }

                // Resume the element editor
                this.elementEditor?.resume();
              });
            }
          );

          this.addingEntry = false;
        });
      },

      getEntryTypeByHandle: function (handle) {
        for (let i = 0; i < this.entryTypes.length; i++) {
          if (this.entryTypes[i].handle === handle) {
            return this.entryTypes[i];
          }
        }
      },

      collapseSelectedEntries: function () {
        this.callOnSelectedEntries('collapse');
      },

      expandSelectedEntries: function () {
        this.callOnSelectedEntries('expand');
      },

      disableSelectedEntries: function () {
        this.callOnSelectedEntries('disable');
      },

      enableSelectedEntries: function () {
        this.callOnSelectedEntries('enable');
      },

      deleteSelectedEntries: function () {
        this.callOnSelectedEntries('selfDestruct');
      },

      duplicateSelectedEntries: function () {
        this.callOnSelectedEntries('duplicate');
      },

      callOnSelectedEntries: function (fn) {
        for (let i = 0; i < this.entrySelect.$selectedItems.length; i++) {
          this.entrySelect.$selectedItems.eq(i).data('entry')[fn]();
        }
      },

      getHiddenEntryCss: function ($entry) {
        return {
          opacity: 0,
          marginBottom: -$entry.outerHeight(),
        };
      },

      get maxEntries() {
        return this.settings.maxEntries;
      },

      destroy: function () {
        this.entrySort?.destroy();
        this.entrySelect?.destroy();
        delete this.entrySort;
        delete this.entrySelect;

        this.$entriesContainer.children('.matrixblock').each((i, container) => {
          $(container).data('entry')?.destroy();
        });

        this.base();
      },
    },
    {
      defaults: {
        fieldId: null,
        maxEntries: null,
        namespace: null,
        baseInputName: null,
        ownerElementType: null,
        ownerId: null,
        siteId: null,
        staticEntries: false,
      },

      collapsedEntryStorageKey:
        'Craft-' + Craft.systemUid + '.MatrixInput.collapsedEntries',

      getCollapsedEntryIds: function () {
        if (
          typeof localStorage[Craft.MatrixInput.collapsedEntryStorageKey] ===
          'string'
        ) {
          return Craft.filterArray(
            localStorage[Craft.MatrixInput.collapsedEntryStorageKey].split(',')
          );
        } else {
          return [];
        }
      },

      setCollapsedEntryIds: function (ids) {
        localStorage[Craft.MatrixInput.collapsedEntryStorageKey] =
          ids.join(',');
      },

      rememberCollapsedEntryId: function (id) {
        if (typeof Storage !== 'undefined') {
          const collapsedEntries = Craft.MatrixInput.getCollapsedEntryIds();

          if ($.inArray('' + id, collapsedEntries) === -1) {
            collapsedEntries.push(id);
            Craft.MatrixInput.setCollapsedEntryIds(collapsedEntries);
          }
        }
      },

      forgetCollapsedEntryId: function (id) {
        if (typeof Storage !== 'undefined') {
          const collapsedEntries = Craft.MatrixInput.getCollapsedEntryIds();
          const collapsedEntriesIndex = $.inArray('' + id, collapsedEntries);

          if (collapsedEntriesIndex !== -1) {
            collapsedEntries.splice(collapsedEntriesIndex, 1);
            Craft.MatrixInput.setCollapsedEntryIds(collapsedEntries);
          }
        }
      },

      initTabs(container) {
        const $tabs = $(container).children('.pane-tabs');
        if (!$tabs.length) {
          return;
        }

        // init tab manager
        let tabManager = new Craft.Tabs($tabs);

        // prevent items in the disclosure menu from changing the URL
        let disclosureMenu = tabManager.$menuBtn.data('trigger');
        $(disclosureMenu.$container)
          .find('li, a')
          .on('click', function (ev) {
            ev.preventDefault();
          });

        tabManager.on('selectTab', (ev) => {
          const href = ev.$tab.attr('href');

          // Show its content area
          if (href && href.charAt(0) === '#') {
            $(href).removeClass('hidden');
          }

          // Trigger a resize event to update any UI components that are listening for it
          Garnish.$win.trigger('resize');

          // Fixes Redactor fixed toolbars on previously hidden panes
          Garnish.$doc.trigger('scroll');
        });

        tabManager.on('deselectTab', (ev) => {
          const href = ev.$tab.attr('href');
          if (href && href.charAt(0) === '#') {
            // Hide its content area
            $(ev.$tab.attr('href')).addClass('hidden');
          }
        });

        return tabManager;
      },
    }
  );

  Craft.MatrixInput.Entry = Garnish.Base.extend({
    /**
     * @type {Craft.MatrixInput}
     */
    matrix: null,
    $container: null,
    $titlebar: null,
    $tabContainer: null,
    $fieldsContainer: null,
    $previewContainer: null,
    $actionMenu: null,
    $collapsedInput: null,

    tabManager: null,
    actionDisclosure: null,
    formObserver: null,
    visibleLayoutElements: null,
    staticLayoutElements: null,
    cancelToken: null,
    ignoreFailedRequest: false,

    isNew: null,
    id: null,

    collapsed: false,

    init: function (matrix, $container) {
      this.matrix = matrix;
      this.$container = $container;
      this.$titlebar = $container.children('.titlebar');
      this.$tabContainer = this.$titlebar.children('.matrixblock-tabs');
      this.$previewContainer = this.$titlebar.children('.preview');
      this.$fieldsContainer = $container.children('.fields');

      this.$container.data('entry', this);

      this.id = this.$container.data('id');
      this.isNew =
        !this.id ||
        (typeof this.id === 'string' && this.id.substring(0, 3) === 'new');

      if (this.$tabContainer.length) {
        this.tabManager = Craft.MatrixInput.initTabs(this.$tabContainer);
      }

      const $actionMenuBtn = this.$container.find('> .actions > .action-btn');
      const actionDisclosure =
        $actionMenuBtn.data('disclosureMenu') ||
        new Garnish.DisclosureMenu($actionMenuBtn);

      this.$actionMenu = actionDisclosure.$container;
      this.actionDisclosure = actionDisclosure;

      actionDisclosure.on('show', () => {
        this.$container.addClass('active');
        const hideActions = [];

        if (this.collapsed) {
          hideActions.push('collapse');
        } else {
          hideActions.push('expand');
        }

        if (this.$container.hasClass('disabled-entry')) {
          hideActions.push('disable');
        } else {
          hideActions.push('enable');
        }

        if (!this.$container.prev('.matrixblock').length) {
          hideActions.push('moveUp');
        }

        if (!this.$container.next('.matrixblock').length) {
          hideActions.push('moveDown');
        }

        if (!this.matrix.canAddMoreEntries()) {
          hideActions.push('add');
          hideActions.push('duplicate');
        }

        const $buttons = this.$actionMenu.find('button[data-action]');
        const $hideButtons = hideActions.length
          ? $buttons.filter(
              hideActions.map((a) => `[data-action=${a}]`).join(',')
            )
          : $();

        const disclosureMenu = this.$actionMenu.data('disclosureMenu');
        $hideButtons.each((i, button) => {
          disclosureMenu.hideItem(button);
        });
        $buttons.not($hideButtons).each((i, button) => {
          disclosureMenu.showItem(button);
        });
      });

      actionDisclosure.on('hide', () => {
        this.$container.removeClass('active');
      });

      this.$actionMenuOptions = this.$actionMenu.find('button[data-action]');

      this.addListener(
        this.$actionMenuOptions,
        'activate',
        this.handleActionClick
      );

      // Was this entry already collapsed?
      if (Garnish.hasAttr(this.$container, 'data-collapsed')) {
        this.collapse();
      }

      this._handleTitleBarClick = function (ev) {
        // don't expand/collapse the matrix "block" if double tapping the tabs
        if (!$(ev.target).closest('.tab-label').length) {
          ev.preventDefault();
          this.toggle();
        }
      };

      this.addListener(this.$titlebar, 'doubletap', this._handleTitleBarClick);

      this.visibleLayoutElements = this.$container.data(
        'visible-layout-elements'
      );
      this.staticLayoutElements = this.$container.data(
        'static-layout-elements'
      );
      this.formObserver = new Craft.FormObserver(this.$container, (data) => {
        this.updateFieldLayout(data);
      });
    },

    toggle: function () {
      if (this.collapsed) {
        this.expand();
      } else {
        this.collapse(true);
      }
    },

    collapse: function (animate) {
      if (this.collapsed) {
        return;
      }

      this.$container.addClass('collapsed');

      let previewHtml = '';
      const $fields = this.$fieldsContainer.children().children();

      for (let i = 0; i < $fields.length; i++) {
        const $field = $($fields[i]);
        const $inputs = $field
          .children('.input')
          .find('select,input[type!="hidden"],textarea,.label');
        let inputPreviewText = '';

        for (let j = 0; j < $inputs.length; j++) {
          const $input = $($inputs[j]);
          let value;

          if ($input.hasClass('label')) {
            const $lightswitch = $input.closest('.lightswitch');
            if (
              $lightswitch.length &&
              (($lightswitch.hasClass('on') && $input.hasClass('off')) ||
                (!$lightswitch.hasClass('on') && $input.hasClass('on')))
            ) {
              continue;
            }

            if ($input.closest('button[aria-pressed=false]').length) {
              continue;
            }

            value = $input.text();
          } else {
            value = Craft.getText(this._inputPreviewText($input));
          }

          if (Array.isArray(value)) {
            value = value.join(', ');
          }

          if (value) {
            value = Craft.escapeHtml(value).trim();

            if (value) {
              if (inputPreviewText) {
                inputPreviewText += ', ';
              }

              inputPreviewText += value;
            }
          }
        }

        if (inputPreviewText) {
          previewHtml +=
            (previewHtml ? ' <span>|</span> ' : '') + inputPreviewText;
        }
      }

      this.$previewContainer.html(previewHtml);

      this.$fieldsContainer.velocity('stop');
      this.$container.velocity('stop');

      if (animate && !Garnish.prefersReducedMotion()) {
        this.$fieldsContainer.velocity('fadeOut', {duration: 'fast'});
        this.$container.velocity({height: 30}, 'fast');
      } else {
        this.$previewContainer.show();
        this.$fieldsContainer.hide();
        this.$container.css({height: 30});
      }

      this.$tabContainer.hide();

      // Remember that?
      if (!this.isNew) {
        Craft.MatrixInput.rememberCollapsedEntryId(this.id);
      } else {
        if (!this.$collapsedInput) {
          this.$collapsedInput = $(
            '<input type="hidden" name="' +
              this.matrix.inputNamePrefix +
              '[entries][' +
              this.id +
              '][collapsed]" value="1"/>'
          ).appendTo(this.$container);
        } else {
          this.$collapsedInput.val('1');
        }
      }

      this.collapsed = true;
    },

    _inputPreviewText: function ($input) {
      if ($input.is('select,multiselect')) {
        const labels = [];
        const $options = $input.find('option:selected');
        for (let k = 0; k < $options.length; k++) {
          labels.push($options.eq(k).text());
        }
        return labels;
      }

      if (
        $input.is('input[type="checkbox"]:checked,input[type="radio"]:checked')
      ) {
        const id = $input.attr('id');
        const $label = $(`label[for="${id}"]`);
        if ($label.length) {
          return $label.text();
        }
      }

      return Garnish.getInputPostVal($input);
    },

    expand: function () {
      if (!this.collapsed) {
        return;
      }

      this.$container.removeClass('collapsed');

      this.$fieldsContainer.velocity('stop');
      this.$container.velocity('stop');

      const collapsedContainerHeight = this.$container.height();
      this.$container.height('auto');
      this.$fieldsContainer.show();
      const expandedContainerHeight = this.$container.height();
      const displayValue = this.$fieldsContainer.css('display') || 'block';
      this.$container.height(collapsedContainerHeight);
      this.$fieldsContainer
        .hide()
        .velocity('fadeIn', {duration: 'fast', display: displayValue});

      const animationDuration = Garnish.prefersReducedMotion() ? 0 : 'fast';
      this.$container.velocity(
        {height: expandedContainerHeight},
        animationDuration,
        () => {
          this.$previewContainer.html('');
          this.$container.height('auto');
          this.$container.trigger('scroll');
          this.$tabContainer.show();
        }
      );

      // Remember that?
      if (!this.isNew && typeof Storage !== 'undefined') {
        const collapsedEntries = Craft.MatrixInput.getCollapsedEntryIds();
        const collapsedEntriesIndex = $.inArray('' + this.id, collapsedEntries);

        if (collapsedEntriesIndex !== -1) {
          collapsedEntries.splice(collapsedEntriesIndex, 1);
          Craft.MatrixInput.setCollapsedEntryIds(collapsedEntries);
        }
      }

      if (!this.isNew) {
        Craft.MatrixInput.forgetCollapsedEntryId(this.id);
      } else if (this.$collapsedInput) {
        this.$collapsedInput.val('');
      }

      this.collapsed = false;
    },

    disable: function () {
      this.$container.children('input[name$="[enabled]"]:first').val('');
      this.$container.addClass('disabled-entry');
      this.collapse(true);
    },

    enable: function () {
      this.$container.children('input[name$="[enabled]"]:first').val('1');
      this.$container.removeClass('disabled-entry');
    },

    moveUp: function () {
      this.matrix.trigger('beforeMoveEntryUp', {
        entry: this,
      });
      let $prev = this.$container.prev('.matrixblock');
      if ($prev.length) {
        this.$container.insertBefore($prev);
        this.matrix.entrySelect.resetItemOrder();
      }
      this.matrix.trigger('moveEntryUp', {
        entry: this,
      });
    },

    moveDown: function () {
      this.matrix.trigger('beforeMoveEntryDown', {
        entry: this,
      });
      let $next = this.$container.next('.matrixblock');
      if ($next.length) {
        this.$container.insertAfter($next);
        this.matrix.entrySelect.resetItemOrder();
      }
      this.matrix.trigger('moveEntryDown', {
        entry: this,
      });
    },

    duplicate: function () {
      const type = this.$container.data('type');
      const elementEditor = this.matrix.elementEditor;
      this.matrix.addEntry(type, this.$container.next('.matrixblock'), true, {
        duplicate: elementEditor?.getDraftElementId(this.id) || this.id,
      });
    },

    handleActionClick: function (event) {
      event.preventDefault();
      this.onActionSelect(event.target);
    },

    onActionSelect: function (option) {
      const batchAction =
          this.matrix.entrySelect.totalSelected > 1 &&
          this.matrix.entrySelect.isSelected(this.$container),
        $option = $(option);

      switch ($option.data('action')) {
        case 'collapse': {
          if (batchAction) {
            this.matrix.collapseSelectedEntries();
          } else {
            this.collapse(true);
          }

          break;
        }

        case 'expand': {
          if (batchAction) {
            this.matrix.expandSelectedEntries();
          } else {
            this.expand();
          }

          break;
        }

        case 'disable': {
          if (batchAction) {
            this.matrix.disableSelectedEntries();
          } else {
            this.disable();
          }

          break;
        }

        case 'enable': {
          if (batchAction) {
            this.matrix.enableSelectedEntries();
          } else {
            this.enable();
            this.expand();
          }

          break;
        }

        case 'moveUp': {
          this.moveUp();
          break;
        }

        case 'moveDown': {
          this.moveDown();
          break;
        }

        case 'editEntryType': {
          new Craft.CpScreenSlideout('entry-types/edit', {
            params: {
              entryTypeId: this.$container.data('type-id'),
            },
          });
          break;
        }

        case 'add': {
          const type = $option.data('type');
          this.matrix.addEntry(type, this.$container);
          break;
        }

        case 'duplicate': {
          if (batchAction) {
            this.matrix.duplicateSelectedEntries();
          } else {
            this.duplicate();
          }

          break;
        }

        case 'copy': {
          let elementInfo = [];
          if (batchAction) {
            let selectedItems = this.matrix.entrySelect.getSelectedItems();
            for (let i = 0; i < selectedItems.length; i++) {
              let entry = $(selectedItems[i]).data('entry');

              elementInfo.push({
                type: 'craft\\elements\\Entry',
                id:
                  entry.matrix.elementEditor?.getDraftElementId(entry.id) ||
                  entry.id,
                draftId: entry.$container.data('draftId'),
                revisionId: entry.$container.data('revisionId'),
                fieldId: entry.matrix.settings.fieldId,
                ownerId: entry.matrix.settings.ownerId,
                siteId: entry.matrix.settings.siteId,
              });
            }
          } else {
            elementInfo = [
              {
                type: 'craft\\elements\\Entry',
                id:
                  this.matrix.elementEditor?.getDraftElementId(this.id) ||
                  this.id,
                draftId: this.$container.data('draftId'),
                revisionId: this.$container.data('revisionId'),
                fieldId: this.matrix.settings.fieldId,
                ownerId: this.matrix.settings.ownerId,
                siteId: this.matrix.settings.siteId,
              },
            ];
          }

          Craft.cp.copyElements(elementInfo);
          break;
        }

        case 'delete': {
          if (batchAction) {
            if (
              confirm(
                Craft.t(
                  'app',
                  'Are you sure you want to delete the selected {type}?',
                  {
                    type: Craft.elementTypeNames['craft\\elements\\Entry'][3],
                  }
                )
              )
            ) {
              this.matrix.deleteSelectedEntries();
            }
          } else {
            this.selfDestruct();
          }

          break;
        }
      }

      this.actionDisclosure?.hide();
    },

    selfDestruct: function () {
      this.destroy();

      // Remove any inputs from the form data
      $('[name]', this.$container).removeAttr('name');

      this.$container.velocity(
        this.matrix.getHiddenEntryCss(this.$container),
        'fast',
        () => {
          this.$container.remove();
          this.matrix.updateAddEntryBtn();

          this.matrix.trigger('entryDeleted', {
            $entry: this.$container,
          });
        }
      );
    },

    updateFieldLayout(data) {
      return new Promise((resolve, reject) => {
        const elementEditor = this.matrix.elementEditor;
        const baseInputName = this.$container.data('base-input-name');

        // Ignore if we're already submitting the main form
        if (elementEditor?.submittingForm) {
          reject('Form already being submitted.');
          return;
        }

        if (this.cancelToken) {
          this.ignoreFailedRequest = true;
          this.cancelToken.cancel();
        }

        const param = (n) => Craft.namespaceInputName(n, baseInputName);
        const extraData = {
          [param('visibleLayoutElements')]: this.visibleLayoutElements,
          [param('staticLayoutElements')]: this.staticLayoutElements,
          [param('elementType')]: 'craft\\elements\\Entry',
          [param('ownerId')]: this.matrix.settings.ownerId,
          [param('fieldId')]: this.matrix.settings.fieldId,
          [param('sortOrder')]: this.$container.index() + 1,
          [param('typeId')]: this.$container.data('type-id'),
          [param('elementUid')]:
            elementEditor?.getDraftElementUid(this.$container.data('uid')) ??
            this.$container.data('uid'),
        };

        const selectedTabId = this.$fieldsContainer
          .children('[data-layout-tab]:not(.hidden)')
          .data('id');
        if (selectedTabId) {
          extraData[param('selectedTab')] = selectedTabId;
        }

        data += `&${$.param(extraData)}`;

        this.cancelToken = axios.CancelToken.source();

        Craft.sendActionRequest('POST', 'elements/update-field-layout', {
          cancelToken: this.cancelToken.token,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'X-Craft-Namespace': baseInputName,
          },
          data,
        })
          .then((response) => {
            this._afterUpdateFieldLayout(
              data,
              selectedTabId,
              baseInputName,
              response
            );
            resolve();
          })
          .catch((e) => {
            if (!this.ignoreFailedRequest) {
              reject(e);
            }
            this.ignoreFailedRequest = false;
          })
          .finally(() => {
            this.cancelToken = null;
          });
      });
    },

    async _afterUpdateFieldLayout(
      data,
      selectedTabId,
      baseInputName,
      response
    ) {
      // capture the new selected tab ID, in case it just changed
      const newSelectedTabId = this.$fieldsContainer
        .children('[data-layout-tab]:not(.hidden)')
        .data('id');

      // Update the visible elements
      let $allTabContainers = $();
      const visibleLayoutElements = {};
      const staticLayoutElements = {};
      let changedElements = false;

      for (const tabInfo of response.data.missingElements) {
        let $tabContainer = this.$fieldsContainer.children(
          `[data-layout-tab="${tabInfo.uid}"]`
        );

        if (!$tabContainer.length) {
          $tabContainer = $('<div/>', {
            id: Craft.namespaceId(tabInfo.id, baseInputName),
            class: 'flex-fields',
            'data-id': tabInfo.id,
            'data-layout-tab': tabInfo.uid,
          });
          if (tabInfo.id !== selectedTabId) {
            $tabContainer.addClass('hidden');
          }
          $tabContainer.appendTo(this.$fieldsContainer);
        }

        $allTabContainers = $allTabContainers.add($tabContainer);

        for (const elementInfo of tabInfo.elements) {
          if (elementInfo.html !== false) {
            if (!visibleLayoutElements[tabInfo.uid]) {
              visibleLayoutElements[tabInfo.uid] = [];
            }
            visibleLayoutElements[tabInfo.uid].push(elementInfo.uid);

            if (elementInfo.static) {
              if (!staticLayoutElements[tabInfo.uid]) {
                staticLayoutElements[tabInfo.uid] = [];
              }
              staticLayoutElements[tabInfo.uid].push(elementInfo.uid);
            }

            if (typeof elementInfo.html === 'string') {
              const $oldElement = $tabContainer.children(
                `[data-layout-element="${elementInfo.uid}"]`
              );
              const $newElement = $(elementInfo.html);
              if ($oldElement.length) {
                $oldElement.replaceWith($newElement);
              } else {
                $newElement.appendTo($tabContainer);
              }
              Craft.initUiElements($newElement);
              changedElements = true;
            }
          } else {
            const $oldElement = $tabContainer.children(
              `[data-layout-element="${elementInfo.uid}"]`
            );
            if (
              !$oldElement.length ||
              !Garnish.hasAttr($oldElement, 'data-layout-element-placeholder')
            ) {
              const $placeholder = $('<div/>', {
                class: 'hidden',
                'data-layout-element': elementInfo.uid,
                'data-layout-element-placeholder': '',
              });

              if ($oldElement.length) {
                $oldElement.replaceWith($placeholder);
              } else {
                $placeholder.appendTo($tabContainer);
              }

              changedElements = true;
            }
          }
        }
      }

      // Remove any unused tab content containers
      // (`[data-layout-tab=""]` == unconditional containers, so ignore those)
      const $unusedTabContainers = this.$fieldsContainer
        .children('[data-layout-tab]')
        .not($allTabContainers)
        .not('[data-layout-tab=""]');
      if ($unusedTabContainers.length) {
        $unusedTabContainers.remove();
        changedElements = true;
      }

      // Make the first tab visible if no others are
      if (!$allTabContainers.filter(':not(.hidden)').length) {
        $allTabContainers.first().removeClass('hidden');
      }

      this.visibleLayoutElements = visibleLayoutElements;
      this.staticLayoutElements = staticLayoutElements;

      // Update the tabs
      if (this.tabManager) {
        this.tabManager.destroy();
        this.tabManager = null;
        this.$tabContainer.html('');
      }

      this.hasTabs = !!response.data.tabs;

      if (this.hasTabs) {
        this.$tabContainer.append(response.data.tabs);
        this.tabManager = Craft.MatrixInput.initTabs(this.$tabContainer);

        // was a new tab selected after the request was kicked off?
        if (
          selectedTabId &&
          newSelectedTabId &&
          selectedTabId !== newSelectedTabId
        ) {
          const $newSelectedTab = this.tabManager.$tabs.filter(
            `[data-id="${newSelectedTabId}"]`
          );
          if ($newSelectedTab.length) {
            // if the new tab is visible - switch to it
            this.tabManager.selectTab($newSelectedTab);
          } else {
            // if the new tab is not visible (e.g. hidden by a condition)
            // switch to the first tab
            this.tabManager.selectTab(this.tabManager.$tabs.first());
          }
        }
      }

      await Craft.appendHeadHtml(response.data.headHtml);
      await Craft.appendBodyHtml(response.data.bodyHtml);

      // re-grab dismissible tips, re-attach listener, hide on re-load
      this.matrix.elementEditor?.handleDismissibleTips();
    },

    destroy: function () {
      this.actionDisclosure?.hide();

      this.tabManager?.destroy();
      this.actionDisclosure?.destroy();
      this.formObserver?.destroy();
      delete this.tabManager;
      delete this.actionDisclosure;
      delete this.formObserver;

      // alert any nested inputs that we're getting deleted
      this.$container.trigger('delete');

      this.base();
    },
  });
})(jQuery);
